module.exports = __webpack_public_path__ + "static/img/video.ff2d310a.jpg";